import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';

export default class LocationOverviewAiWatchlistController extends Controller {
  @service declare reactRenderer: ReactRendererService;
  @service declare state: StateService;

  private root?: Root;
  #generation = 0;

  @action
  async injectComponent(): Promise<void> {
    const generation = this.#generation;

    const { AiWatchlist } = await import('reactRichComponents/visitors/AiWatchlist');
    if (generation !== this.#generation) return;

    let root: Root;
    try {
      root = await this.reactRenderer.render(AiWatchlist, 'react__visitors__ai-watchlist', {
        companyId: this.state.currentCompany.id,
        locationId: this.state.currentLocation.id,
      });
    } catch (error) {
      if (generation !== this.#generation) return;
      throw error;
    }

    if (generation !== this.#generation) {
      this.reactRenderer.unmount(root);
      return;
    }

    this.root = root;
  }

  @action
  destroyComponent(): void {
    this.#generation++;
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
